export enum CampaignFieldTypeEnum {
  FIRSTNAME = 'firstname',
  LASTNAME = 'lastname',
  EMAIL = 'email',
  MOBILE = 'mobile',
  BIRTHDAY = 'birthday',
  CITY = 'city',
  ZIP_CODE = 'zip_code',
  STREET = 'street',
  HOUSE_NUMBER = 'house_number',
  FLAT_NUMBER = 'flat_number',
  SHORT_TEXT = 'short_text',
  LONG_TEXT = 'long_text',
  FILE = 'file',
  SINGLE_CHOICE = 'single_choice',
  MULTIPLE_CHOICE = 'multiple_choice',
  AGREEMENT_COMPETITION = 'agreement_competition',
  AGREEMENT_EMAIL = 'agreement_email',
  AGREEMENT_SMS = 'agreement_sms',
  AGREEMENT_MOBILE = 'agreement_mobile',
  AGREEMENT_WHATSAPP = 'agreement_whatsapp',
}
